<template>
  <v-alert border="start" border-color="deep-purple" class="ma-2 pa-0" elevation="5">
    <template v-slot:title>
      <v-text-field
          density="compact"
          variant="solo"
          :label="list.name === '' || list.name === null ? 'Название раздела' : null"
          single-line
          hide-details
          v-model="local_list.name"
      >
        <template v-slot:append-inner>
          <v-icon class="trash-btn" v-on:click="delete_section()" :icon="['fas', 'trash']" />
        </template>
      </v-text-field>
    </template>
    <template v-slot:text>
      <div class="ma-4">
        <draggable
            class="group_list"
            :list="list.groups"
            v-bind="dragOptions"
            group="groups"
            @start="drag=true"
            @end="onDragEnd()"
            item-key="id">
          <template #item="{element}">
            <GroupElement :group="element" :section_guid="list.guid" v-if="element"/>
          </template>
        </draggable>
      </div>
    </template>
  </v-alert>
</template>

<script>
import draggable from "vuedraggable";
import { ReportData } from "@/store/report/ReportData";
import GroupElement from "@/components/Reports/Editor__Tool/DragBlocks/GroupElement.vue";

export default {
  name: "SectionElement",
  props: ['list', 'id'],
  components: { GroupElement, draggable },
  data() {
    return {
      drag: false
    }
  },
  methods: {
    onDragEnd: function () {
      this.drag = false
      this.recalculatePages()
    },
    recalculatePages: function () {
      console.log('Пересчитываю страницы!')
      let page = 1
      this.report_data.section_list.forEach((section) => {
        section.groups.forEach((group) => {
          group.page = page
          page++
        })
      })
    },
    delete_section: function () {
      console.log('Удалил секцию')
      for (let page of this.list.groups) {
        for (let report of page.reports) {
          this.report_data['unused'].push(report)
        }
      }
      this.report_data.section_list.splice(this.report_data.section_list.indexOf(this.report_data.section_list.find(section => this.list.guid === section.guid)), 1)
    }
  },
  computed: {
    local_list: {
      get () { return this.list },
      set (value) { this.$emit('update:list', value) },
    },
    dragOptions() {
      return {
        animation: 200,
        group: "groups",
        disabled: false,
        ghostClass: "ghost"
      };
    },
    report_data: {
      get() {
        return ReportData().get()
      },
      set(value) {
        ReportData().set(value)
      }
    }
  }
}
</script>

<style scoped>
.trash-btn {
  transition: 0.1s;
}
.trash-btn:hover {
  color: #FF5722;
  cursor: pointer;
}
</style>
